/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents what kind of registrations are allowed for the case. A hybrid registration type allows both person and organization to register for a case.
 */
export const CaseRegistrationType = {
    PersonOnly: 1,
    OrganizationOnly: 2,
    Hybrid: 3
} as const;
export type CaseRegistrationType = typeof CaseRegistrationType[keyof typeof CaseRegistrationType];

